"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var serverCookie = __importStar(require("cookie"));
var config_1 = require("@skillrecordings/config");
var serializeCookie = function (value, options) {
    if (config_1.CK_SUBSCRIBER_KEY) {
        return serverCookie.serialize(config_1.CK_SUBSCRIBER_KEY, value, options);
    }
    else {
        console.error('NEXT_PUBLIC_CONVERTKIT_SUBSCRIBER_KEY is empty, please set it in your dot env file.');
        return '';
    }
};
/**
 * @deprecated use convertkit-sdk instead
 * @param subscriberId
 */
function serializeConvertkitCookie(subscriberId) {
    var hour = 3600000;
    var oneYear = 365 * 24 * hour;
    return serializeCookie(subscriberId, {
        secure: process.env.NODE_ENV === 'production',
        httpOnly: true,
        path: '/',
        maxAge: oneYear,
    });
}
exports.default = serializeConvertkitCookie;
